import React from 'react';
import CalendarioAgendamento from '../../components/CalendarioAgendamento/index';
import ModalPreCadastro from '../../components/ModalPreCadastro';
import ModalAgendados from '../../components/ModalAgendados';
import ModalAgendamentosPorPeriodo from '../../components/ModalAgendamentosPorPeriodo';
import ModalAgendamento from '../../components/ModalAgendamento';
import Header from '../../components/Header/index';
import Footer from  '../../components/Footer/index';
import './styles.css';
import { Row, Col } from 'antd';
import ModalAgendamentoInfo from '../../components/ModalAgendamentoInfo';

const Home = () => {
    return (
        <div>
            <Header></Header>
            <div className="conteudo">
                <Row>
                    <Col span={24}>
                        <div className="calendarioApp">
                            <CalendarioAgendamento/>                            
                        </div>
                    </Col>
                </Row>
            </div>
            <Footer></Footer>
            <ModalPreCadastro></ModalPreCadastro>
            <ModalAgendamento></ModalAgendamento>
            <ModalAgendados></ModalAgendados>
            <ModalAgendamentosPorPeriodo></ModalAgendamentosPorPeriodo>
            <ModalAgendamentoInfo></ModalAgendamentoInfo>           
        </div>
    );
}

export default Home;